module.exports = __webpack_public_path__ + "static/base-7ff9e3de2ba135776415df5d3543c802.png";